// コメント管理単位種別
export enum ReceptionCommentUnitKinds {
  Multiple = 0, // 複数
  Single = 1, // 単一
}
